module.exports = __webpack_public_path__ + "static/media/music_light.1a49cf10.svg";